import { render, staticRenderFns } from "./AppTransition.vue?vue&type=template&id=2cadc810&scoped=true&"
import script from "./AppTransition.vue?vue&type=script&lang=ts&"
export * from "./AppTransition.vue?vue&type=script&lang=ts&"
import style0 from "./AppTransition.vue?vue&type=style&index=0&id=2cadc810&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cadc810",
  null
  
)

export default component.exports